import './popup.scss';
import { execOnLoad } from '@general/helpers';
import Cookies from 'js-cookie';
import { openModal } from '../../scripts/components/modals';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initPopup = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const modal = sectionContainer.querySelector(
    '.modal[data-delay][data-cookie-duration]',
  );
  if (!modal) return;

  const delay = parseInt(modal.dataset.delay) * 1000;
  const cookieDuration = parseInt(modal.dataset.cookieDuration);
  const id = modal.id;
  const cookie = `modal-${id}-closed`;

  setTimeout(() => {
    if (Cookies.get(cookie) !== 'true') openModal(`#${id}`, false);
  }, delay);

  modal
    .querySelectorAll('.modal__backdrop , .modal__close')
    .forEach((closer) =>
      closer.addEventListener('click', () =>
        Cookies.set(cookie, 'true', { expires: cookieDuration }),
      ),
    );
};

execOnLoad(window.dAgency.initPopup, '.popup__section');
